export default () => ({
    eventData: null,
    remainingPlaces: null,
    availabilities: null,
    reservedPlaces: null,
    reservedAvailabilities: null,
    occupancy: null,
    registrationData: {
        requestId: null,
        id: null,
        openRequests: null,
        answers: {},
        groupRegistrarToken: null,
        groupParticipantToken: null,
        groupName: null,
        noCheckToken: null,
        participatingPersons: [],
        deletedParticipatingPersons: [],
        invoiceReceivingPerson: null,
        persons: {},
        paymentType: null,
        couponsToRedeem: [],
        redeemedCoupons: []
    },
    newsletterData: {
        email: null,
        salutation: null,
        firstname: null,
        lastname: null,
        profiles: []
    },
    formSelectChoices: null,
    onlineRegistrationFields: [],
    caregiver: null,
    caregiverOptions: null,
    eventIsLoaded: false,
    previewMode: false,
    groupRegistrationCreationMode: false,
    caregiverToken: null,
    caregiverCheckToken: null,
    noCheckToken: null,
    groupRegistrarToken: null,
    groupParticipantToken: null,
    stepsValidationState: {},
    stepsValidationSections: {},
    activeSubPage: {},
    initialFemalePlacesTaken: 0,
    initialMalePlacesTaken: 0,
    initialTotalPlacesTaken: 0,
    initialAnswerSelection: {},
    registrationFinishedSuccessful: false,
    tooManyAttemptsAt: null,
    retryAfter: 60,
    remoteVersion: null
})
